import { useSelector } from 'react-redux'

import { RecipeCoreId } from '@library/menu-service'

import { getBasketRecipes } from 'selectors/basket'

export const useIsRecipeInBasket = (coreId: RecipeCoreId | null) => {
  const recipeQuantities = useSelector(getBasketRecipes)

  if (!coreId) {
    return false
  }

  return recipeQuantities?.get(coreId, 0) > 0
}
